import 'ClickKey/angularModule';
import 'ClientStorage/angularModule';
import 'Compile/angularModule';
import 'DialogModal/angularModule';
import 'FormatsText/angularModule';
import 'Translation/angularModule';
import 'EventLogger/angularModule';
import 'ErrorLogging/angularModule';

export default angular.module('FrontRoyal.ClientConfig', [
    'Translation',
    'DialogModal',
    'FormatsText',
    'compileDir',
    'ClickKey',
    'ClientStorage',
    'EventLogger',
    'FrontRoyal.ErrorLogService',
]);
